import { colors as baseColors } from "./colors";

// Warm-palette aliases for cart / checkout / search.
// THIS is the single place to tune input & box colours — every input background,
// border, label and step box across checkout/cart/search reads from here.
// Values point at the main palette (colors.ts); change them there (or re-point below)
// and the whole checkout surface follows. Semantic error/promo are intentionally raw.
export const theme = {
  colors: {
    globalBckg: baseColors.white, // #f8f5f2 warm white — global checkout background
    stepBckg: baseColors.white, // #f8f5f2 — step / box background
    stepCompletedBckg: baseColors.inactive, // #e8e5e2 warm-neutral gray — completed (locked) step, distinct from krem inputs
    inputBckg: baseColors.gray, // #efe3d8 jasny krem — input field background (recessed vs white box)
    fieldBckg: "#ffffff", // form fields: white on the cream boxes, no frame (the bar under the field signals focus and errors)
    fieldBorder: "transparent",
    softBckg: "#fbf9f6", // a step lighter than the cream page, so a box reads as raised without a shadow
    fieldLabelColor: baseColors.secondary, // caption above a field
    labelColor: baseColors.font, // #420808 dark brown — input + label text
    borderColor: baseColors.secondary_opacity, // #e3c8a7 krem — input / divider borders
    borderColorLight: "rgba(227, 200, 167, 0.5)", // krem @50% — extra-delicate borders
    errorColor: "#9A3B1B", // brick from the warm palette instead of pure red: still reads as an error, also as white text on it
    promoColor: "#236F21", // semantic — keep
    shadowColor: "rgba(231, 221, 224, 0.6)", // warm shadow (matches #e7dde0 used on cards)
  },
  others: {
    shadowDegree: "1px 3px 10px 0px",
  },
};
